import { Box, Container, Typography, Divider, Chip, Avatar } from "@mui/material";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import { useGetPublicSchoolInfoQuery } from "../../../../../app/authApiSlice";
import { useGetWebsiteSettingsQuery } from "../../../../../app/websiteApiSlice";
import WebsiteHeader from "../../WebsiteHeader";
import WebsiteFooter from "../../WebsiteFooter";
import SeoHead from "../../SeoHead";
import "./modern.css";

export default function ModernPost({ post, settings: settingsProp }) {
  const { data: school } = useGetPublicSchoolInfoQuery();
  const { data: settings } = useGetWebsiteSettingsQuery(undefined, { skip: !!settingsProp });
  const activeSettings = settingsProp || settings;

  return (
    <Box className="website-modern" sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <SeoHead
        title={post.seo_title || post.title}
        description={post.seo_description || post.excerpt}
        ogImage={post.seo_og_image || post.featured_image}
        schoolName={school?.name}
      />
      <WebsiteHeader school={school} navItems={activeSettings?.nav_items} variant="modern" />

      {post.featured_image && (
        <Box
          component="img"
          src={post.featured_image}
          alt={post.title}
          sx={{ width: "100%", maxHeight: 420, objectFit: "cover" }}
        />
      )}

      <Container maxWidth="md" sx={{ py: 6, flex: 1 }}>
        {/* Categories */}
        <Box display="flex" gap={0.5} flexWrap="wrap" mb={2}>
          {post.categories?.map((c) => (
            <Chip
              key={c.id}
              label={c.name}
              size="small"
              color="primary"
              component={Link}
              to={`/blog/category/${c.slug}`}
              clickable
            />
          ))}
        </Box>

        <Typography variant="h3" fontWeight={800} gutterBottom>{post.title}</Typography>

        {/* Meta */}
        <Box display="flex" alignItems="center" gap={1} mb={3} color="text.secondary">
          <Avatar sx={{ width: 28, height: 28, fontSize: "0.75rem" }}>
            {post.author?.username?.[0]?.toUpperCase()}
          </Avatar>
          <Typography variant="body2">{post.author?.username}</Typography>
          {post.published_at && (
            <>
              <Typography variant="body2">·</Typography>
              <Typography variant="body2">
                {format(new Date(post.published_at), "MMMM d, yyyy")}
              </Typography>
            </>
          )}
        </Box>

        <Divider sx={{ mb: 4 }} />
        <Box
          className="prose-content"
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
      </Container>

      <WebsiteFooter settings={activeSettings} school={school} variant="modern" />
    </Box>
  );
}
